import { Divider, Group, Stack, Text } from '@mantine/core';
import { HiCheckCircle, HiPlus } from 'react-icons/hi2';
import IntegrationCardBase from '@/pages/Integrations/components/IntegrationCardBase.tsx';
import StyledButton from '@/components/StyledButton/StyledButton.tsx';
import { useState } from 'react';
import DeleteIntegrationModal from '@/pages/Integrations/components/DeleteIntegrationModal.tsx';
import useCreateNangoIntegration from '@/hooks/useCreateNangoIntegration.ts';
import { IntegrationInstance, IntegrationProvider } from '@/types/integrations.ts';
import SharePointConnectModal from '@/components/SharePointConnectModal.tsx';
import { isSharePointProvider } from '@/utils/providerKinds.ts';
import {
  getFullTenantLabel,
  getIntegrationInstancePrimaryLabel,
} from '@/utils/integrationDisplay.ts';

type IntegrationCardProps = {
  // integration: IntegrationInstance;
  provider: IntegrationProvider;
  // setSelectedIntegration: (provider?: IntegrationProvider) => void;
};

const IntegrationCard = ({
  // integration,
  provider,
  // setSelectedIntegration,
}: IntegrationCardProps) => {
  const [deleteIntegration, setDeleteIntegration] = useState<IntegrationInstance | null>(null);
  const [sharePointConnectOpened, setSharePointConnectOpened] = useState(false);

  const { createIntegration, createIntegrationFromButton, creatingIntegration } =
    useCreateNangoIntegration();

  const instanceCount = provider.instances.length;

  if (!provider) {
    return null;
  }

  const action = (
    <Group justify="flex-end" gap="2px" onClick={(e) => e.stopPropagation()}>
      <HiCheckCircle color={'#0fa357'} size={18} />
      {/*<Menu*/}
      {/*  position="bottom-start"*/}
      {/*  styles={{*/}
      {/*    dropdown: {*/}
      {/*      boxShadow:*/}
      {/*        'lch(0 0 0 / 0.02) 0px 6px 18px, lch(0 0 0 / 0.04) 0px 3px 9px, lch(0 0 0 / 0.04) 0px 1px 1px',*/}
      {/*    },*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <Menu.Target>*/}
      {/*    <Button*/}
      {/*      variant="subtle"*/}
      {/*      size="xs"*/}
      {/*      loading={!!deleteIntegration}*/}
      {/*      styles={{*/}
      {/*        root: {*/}
      {/*          padding: '5px', // Reduce padding around the icon*/}
      {/*          minWidth: 'auto', // Remove minimum width constraint*/}
      {/*          height: 'auto', // Allow height to be determined by content*/}
      {/*        },*/}
      {/*      }}*/}
      {/*    >*/}
      {/*      <HiMiniEllipsisVertical size={15} color={'#BABABA'} />*/}
      {/*    </Button>*/}
      {/*  </Menu.Target>*/}
      {/*  <Menu.Dropdown>*/}
      {/*    <Menu.Item onClick={() => setSelectedIntegration(provider)}>*/}
      {/*      View Integration Actions*/}
      {/*    </Menu.Item>*/}
      {/*    <Menu.Item color="red" onClick={() => setDeleteIntegration(integration)}>*/}
      {/*      Disconnect*/}
      {/*    </Menu.Item>*/}
      {/*  </Menu.Dropdown>*/}
      {/*</Menu>*/}
      {/*{deleteIntegration && (*/}
      {/*  <DeleteIntegrationModal*/}
      {/*    integration={deleteIntegration}*/}
      {/*    onClose={() => setDeleteIntegration(null)}*/}
      {/*  />*/}
      {/*)}*/}
    </Group>
  );

  return (
    <IntegrationCardBase action={action} provider={provider} showInfoIcon={false}>
      <Divider style={{ borderColor: '#ECECED' }} mt={'xs'} />
      <Stack gap={'xs'} px={'md'} pt={'xs'}>
        <Group justify={'space-between'} w={'100%'} wrap={'nowrap'}>
          <Text size={'11px'}>
            {instanceCount} connection{instanceCount > 1 ? 's' : ''}
          </Text>
          <StyledButton
            size={'sm'}
            variant={'subtleIcon'}
            aria-label={`Add ${provider.display_name} connection`}
            h={'100%'}
            p={'6px'}
            onClick={async (e) => {
              e.stopPropagation();
              if (isSharePointProvider(provider)) {
                setSharePointConnectOpened(true);
                return;
              }
              await createIntegrationFromButton(provider);
            }}
            loading={creatingIntegration}
            style={{ borderRadius: '50%' }}
          >
            <HiPlus size={12} />
          </StyledButton>
        </Group>
        {provider.instances.map((i) => {
          const tenantLabel = getFullTenantLabel(i.sharepoint_tenant_id);
          const connectionLabel = getIntegrationInstancePrimaryLabel(provider, i);

          return (
            <Stack
              key={i.id}
              gap={4}
              px="xs"
              py="6px"
              bg={'#FAFAFA'}
              style={{ borderRadius: '5px' }}
              data-testid={`integration-instance-${i.id}`}
            >
              <Group wrap={'nowrap'} w={'100%'} justify={'space-between'} fw={500}>
                <Text size="11px">{connectionLabel}</Text>
                <StyledButton
                  variant={'outline'}
                  size={'sm'}
                  ml={'auto'}
                  p={'4px'}
                  fw={400}
                  style={{ fontSize: '11px' }}
                  onClick={() => setDeleteIntegration(i)}
                >
                  Disconnect
                </StyledButton>
              </Group>
              {tenantLabel && (
                <Text size="xs" c="#757575">
                  {tenantLabel}
                </Text>
              )}
            </Stack>
          );
        })}
      </Stack>
      {deleteIntegration && (
        <DeleteIntegrationModal
          integration={deleteIntegration}
          provider={provider}
          onClose={() => setDeleteIntegration(null)}
        />
      )}
      {isSharePointProvider(provider) && (
        <SharePointConnectModal
          opened={sharePointConnectOpened}
          onClose={() => setSharePointConnectOpened(false)}
          confirmLoading={creatingIntegration}
          onConfirm={async (sharepointTenantId) => {
            await createIntegration(provider, sharepointTenantId);
            setSharePointConnectOpened(false);
          }}
        />
      )}
    </IntegrationCardBase>
  );
};

export default IntegrationCard;
